import { Card } from "@/components/ui/card";
import { formatDateTime } from "@/lib/format";
import { ClipboardCheck } from "lucide-react";

function Field({ label, value }) {
  return (
    <div>
      <p className="text-xs font-semibold text-patria-muted uppercase tracking-wide">{label}</p>
      <p className="text-sm text-patria-ink mt-1 leading-relaxed whitespace-pre-wrap">{value || "—"}</p>
    </div>
  );
}

export function FeedbackCard({ feedback }) {
  if (!feedback) return null;
  return (
    <Card className="bg-patria-surface border-patria-muted/15 p-6" data-testid="feedback-card">
      <div className="flex items-center gap-2 mb-4">
        <div className="h-8 w-8 rounded-lg bg-patria-green/10 flex items-center justify-center"><ClipboardCheck className="h-4 w-4 text-patria-green" /></div>
        <div>
          <h3 className="font-heading font-semibold text-patria-ink">Stage 0 · Documented Feedback & Gap Record</h3>
          <p className="text-xs text-patria-muted">Logged by {feedback.logged_by?.name} · {formatDateTime(feedback.logged_at)}</p>
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Date(s) feedback given" value={feedback.feedback_dates} />
        <Field label="Result — did the gap change?" value={feedback.result} />
        <div className="sm:col-span-2"><Field label="The specific gap" value={feedback.gap} /></div>
        <Field label="Standard expected" value={feedback.standard} />
        <Field label="Direction & support provided" value={feedback.direction_support} />
      </div>
    </Card>
  );
}
